import SearchFilterRail from './SearchFilterRail';

export default SearchFilterRail;
